import { render, staticRenderFns } from "./AddThirtyWorkSchedules.vue?vue&type=template&id=6b059ed9&"
import script from "./AddThirtyWorkSchedules.vue?vue&type=script&lang=ts&"
export * from "./AddThirtyWorkSchedules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports